import { useRecoilValue } from 'recoil'

import CardWithBorder from '../../../components/CardWithBorder'
import DoughnutChart from '../../../components/DoughnutChart'
import useLocationDateTimeForm from '../../../hooks/useLocationDateTimeForm'
import { ServiceAtom } from '../../../recoil/atoms'
import useGetStoreVisitCountMultiStoreVisit from '../hooks/useGetStoreVisitCountMultiStoreVisit'

function UserCrossVisit({ className }: { className?: string }) {
  const { form } = useLocationDateTimeForm()
  const service = useRecoilValue(ServiceAtom)

  const { storeVisitCountMulti, storeVisitCountMultiLoading } = useGetStoreVisitCountMultiStoreVisit({
    serviceId: service.value,
    siteId: form.siteId,
    floorId: form.floorId,
    siteGroupId: form.siteGroupId,
    fromDate: form.fromDate,
    toDate: form.toDate,
  })

  const labels = ['1店舗', '2店舗', '3店舗', '4店舗', '5店舗', '6店舗', '7店舗', '8店舗以上']
  const labelData = labels.map((label, index) => ({
    id: `visit-${index + 1}`,
    label,
    value: storeVisitCountMulti?.multiStoreVisitsCountDatas[index] ?? 0,
  }))

  return (
    <CardWithBorder className={className} title='複数サイト来訪分布' visible={storeVisitCountMultiLoading}>
      <DoughnutChart labelData={labelData} />
    </CardWithBorder>
  )
}

UserCrossVisit.defaultProps = {
  className: '',
}

export default UserCrossVisit
